import { Box } from "@chakra-ui/layout";
import { Modal } from "antd";
import FormCentroDeCusto from "../../Input/SelectCentroDeCusto/FormCentroDeCusto";
import { CentroDeCustoResponse } from "core/features/centro-de-custo/typings";

interface ModalCentroDeCustoProps {
  isOpenModal: boolean;
  onClose: () => any;
  onSuccess: (id: string) => any;
  tenantId?: string;
  defaultValue?: CentroDeCustoResponse;
}

function ModalCentroDeCusto({
  isOpenModal,
  onClose,
  onSuccess,
  tenantId,
  defaultValue,
}: ModalCentroDeCustoProps) {
  return (
    <Modal
      centered
      visible={isOpenModal}
      footer={null}
      onCancel={onClose}
      destroyOnClose
      width="600px"
    >
      <Box>
        {isOpenModal ? (
          <FormCentroDeCusto
            visible={isOpenModal}
            onClose={onClose}
            onSuccess={onSuccess}
            tenantId={tenantId}
            id={defaultValue?.id}
            defaultValue={defaultValue}
          />
        ) : null}
      </Box>
    </Modal>
  );
}

export default ModalCentroDeCusto;
